import { PrimaryButton, SecondaryButton } from "@/Core/Components/Buttons";
import Modal from "@/Core/Components/Modals/Base/Modal";

type Props = {
    show: boolean;
    onClose: () => void;
};

export const PharmacyRedirectModal = ({ show, onClose }: Props) => {
    return (
        <Modal show={show} onClose={onClose} maxWidth="xl" closeable={true}>
            <div className="p-6 text-center">
                <h1 className="text-2xl">Attention Pharmacies</h1>
                <hr className="my-2 mx-5" />
                <div>
                    Sav-Rx has joined Medimpact's family of companies. As part
                    of this transition, any eob inquires, eft/payment set ups,
                    requests for network participation, contracts or policies
                    and procedure updates, attestations, audit guidelines, and
                    appeals must now be conducted via the Medimpact pharmacy
                    portal. The Sav-Rx pharmacy portal will no longer be used
                    for these functions. Please click on the link below to
                    connect to Medimpact's pharmacy portal. Thank you for your
                    cooperation during this transition.
                </div>
                <div className="flex gap-2 justify-center mt-4">
                    <SecondaryButton onClick={onClose}>
                        Return to Sav-Rx Portal
                    </SecondaryButton>
                    <a href="https://pharmacy.medimpact.com/">
                        <PrimaryButton>Go to Medimpact Portal</PrimaryButton>
                    </a>
                </div>
            </div>
        </Modal>
    );
};
